import {
  Text,
  Badge,
  Inspector,
  Primary14SemiBold,
  Primary13Regular,
  IconCheckCircle,
  IconExclamationTriangle,
  IconCircleX,
  IconCircleInfo,
  AccordionButton,
  AccordionIcon,
  Accordion,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex
} from '@sequencehq/core-components'
import {
  ConfigurationManagementProps,
  ResolvedIntegration
} from 'modules/Integrations/domain'
import { FunctionComponent } from 'react'
import { match } from 'ts-pattern'

export interface HealthStatusConfig {
  label: string
  icon: FunctionComponent<{
    height: string | number | undefined
    width: string | number | undefined
  }>
  sentiment: 'success' | 'highlight' | 'neutral'
}

export const HealthStatusBadge = (props: {
  integration: Pick<ResolvedIntegration, 'authFailure' | 'enabled' | 'state'>
}) => {
  return match(props.integration)
    .with({ authFailure: true }, () => {
      return (
        <Badge
          sentiment="highlight"
          textStyle={Primary13Regular}
          containerStyle={{
            backgroundColor: 'none'
          }}
        >
          <IconExclamationTriangle />
          <Text
            {...Primary13Regular}
            data-testid="inspector.healthStatus.label"
          >
            Auth failure
          </Text>
        </Badge>
      )
    })
    .with({ enabled: false }, () => {
      return (
        <Badge
          sentiment="neutral"
          textStyle={Primary13Regular}
          containerStyle={{
            backgroundColor: 'none'
          }}
        >
          <IconCircleX />
          <Text
            {...Primary13Regular}
            data-testid="inspector.healthStatus.label"
          >
            Inactive
          </Text>
        </Badge>
      )
    })
    .with({ state: 'CONNECTED' }, () => {
      return (
        <Badge
          sentiment="success"
          textStyle={Primary13Regular}
          containerStyle={{
            backgroundColor: 'none'
          }}
        >
          <IconCheckCircle />
          <Text
            {...Primary13Regular}
            data-testid="inspector.healthStatus.label"
          >
            Active
          </Text>
        </Badge>
      )
    })
    .otherwise(() => {
      return (
        <Badge
          sentiment="neutral"
          textStyle={Primary13Regular}
          containerStyle={{
            backgroundColor: 'none'
          }}
        >
          <IconCircleX />
          <Text
            {...Primary13Regular}
            data-testid="inspector.healthStatus.label"
          >
            Inactive
          </Text>
        </Badge>
      )
    })
}

export const DefaultIntegrationManagementInspector: React.FC<
  ConfigurationManagementProps
> = props => {
  return (
    <Inspector>
      <Inspector.ItemGroup>
        <Inspector.IconItem
          data-testid="defaultIntegration.inspector.item"
          content={
            <Inspector.Content
              padding="0px"
              data-testid="inspector.statusWidget"
            >
              <Accordion
                allowMultiple={true}
                defaultIndex={[0, 1]}
                mt="8px"
                px="8px"
              >
                <AccordionItem border="none">
                  <AccordionButton px="8px">
                    <Box
                      as={Flex}
                      flex="1"
                      gap={1}
                      textAlign="left"
                      borderRadius="8px"
                      {...Primary14SemiBold}
                    >
                      <span>Status</span>
                      <AccordionIcon />
                    </Box>
                  </AccordionButton>
                  <AccordionPanel
                    pb={4}
                    px={2}
                    as={Flex}
                    gap={4}
                    flexDirection="column"
                  >
                    <Flex
                      width="100%"
                      justifyContent="space-between"
                      alignItems="center"
                      {...Primary13Regular}
                    >
                      <p>Health</p>
                      <HealthStatusBadge integration={props.integration} />
                    </Flex>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            </Inspector.Content>
          }
          icon={<IconCircleInfo />}
        />
      </Inspector.ItemGroup>
    </Inspector>
  )
}
